// @file enterprise.js
import Cookies from 'js-cookie';

require('velocity-animate');
require('slick-carousel');

const $body = $(document.body);

if ($body.hasClass("page--enterprise")) {
  const ua = require('../components/ua');
  class Enterprise {
    constructor() {
      this.tooltip = require('../components/tooltip').tooltip;
      this.$enterpriseQuote = $('.enterprise-start', $body);
      this.slider = document.getElementById('slider');

      this.attachEvent();
    }

    attachEvent() {

      $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.js_enterprise-customers-carousel',
        autoplay: true,
        autoplaySpeed: 5000,
      });

      $('.js_enterprise-customers-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        centerMode: true,
        prevArrow: false,
        asNavFor: '.slider-for',
        variableWidth: true,
        autoplay: true,
        autoplaySpeed: 5000,
      });
    }
  }

  new Enterprise();

  const $enterprisePricingSection = $('.js_enterprise-plan', $body);
  const $enterprisePricingItemAmount = $('.js_enterprise-plan-price-amount', $enterprisePricingSection);
  const $planSelectionEnterprise = $('.js_enterprise-plan-selection', $enterprisePricingSection);
  const userText = $('.pricing-team__user-text', $enterprisePricingSection).text();
  let planSelectedEnterprise = $('option:selected', $planSelectionEnterprise).val();

  let enterpriseObj = {
    dollar : {
      10: "$1,500",
      20: "$3,000",
      30: "$4,500",
      40: "$6,000",
      50: "$7,500",
      60: "$9,000",
      70: "$10,500",
      80: "$12,000",
      90: "$13,500",
      100: "$15,000",
      110: "$16,500",
      120: "$18,000",
      130: "$19,500",
      140: "$21,000",
      150: "$22,500",
      160: "$24,000",
      170: "$25,500",
      180: "$27,000",
      190: "$28,500",
      200: "$30,000"
    },
    yen : {
      10: 150000,
      20: 300000,
      30: 450000,
      40: 600000,
      50: 750000,
      60: 900000,
      70: 1050000,
      80: 1200000,
      90: 1350000,
      100: 1500000,
      110: 1650000,
      120: 1800000,
      130: 1950000,
      140: 2100000,
      150: 2250000,
      160: 2400000,
      170: 2550000,
      180: 2700000,
      190: 2850000,
      200: 3000000,
    }
  };

  let currencyCode = enterpriseObj.dollar;
  let taxJP = 1.1;// Japanese Tax

  $enterprisePricingItemAmount.text(currencyCode[100]);

  if (Cacoo.settings.lang === "ja" || Cookies.get('currencyCode') === "JPY") {
    currencyCode = enterpriseObj.yen;
    $enterprisePricingItemAmount.text( '¥' + Math.floor(currencyCode[100] * taxJP).toLocaleString() );
  }

  enterpriseUserOptions();

  $planSelectionEnterprise.on("change", function(e) {
    planSelectedEnterprise = $('option:selected', $(this)).val();
    updateEnterprisePrice();
  });

  function updateEnterprisePrice() {
    $.each (currencyCode, function (i, val) {
        if (i === planSelectedEnterprise) {
          planSelectedEnterprise = val;
          if ( Cacoo.settings.lang === "ja" || Cookies.get('currencyCode') === "JPY" ) {
            $enterprisePricingItemAmount.text( '¥' + Math.floor(planSelectedEnterprise * taxJP).toLocaleString() );
          } else {
            $enterprisePricingItemAmount.text(planSelectedEnterprise);
          }
        }
    });
  }

  function enterpriseUserOptions() {
    let minUsers = false;
    $.each (enterpriseObj.dollar, function (i, val) {
      if (i === '100') {
        minUsers = true;
      } else {
        minUsers = false;
      }

      $planSelectionEnterprise.append( `<option value="${i}" ${minUsers ? "selected" : "" }> ${i} ${userText}</option>`);
    });
  }
}
